export class ComProductSharedModel {
    public commission?:number;
    public employeeJobId?:number;
    public groupCollectId?:number;
    public maxCollect?:number;
    public minCollect?:number;
    public productosCOEId?:number;
    public sharedCommissionId?:number;
    
    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}